import { motion } from 'framer-motion';
import { HiArrowRight } from 'react-icons/hi';

const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="min-h-screen pt-24 md:pt-32 pb-16 md:pb-24 bg-[#FDFBF7] relative overflow-hidden"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[80vh]">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="order-2 lg:order-1"
          >
            <p className="overline text-[#7A8B71] mb-6" data-testid="hero-overline">
              Leadership & Workplace Well-being Advisor
            </p>
            
            <h1 className="heading-1 text-[#0A192F] mb-6" data-testid="hero-headline">
              Build High-Performing Teams{' '}
              <span className="italic">Without Burnout</span>
            </h1>
            
            <p className="body-large text-[#4A5568] mb-10 max-w-xl" data-testid="hero-subheadline">
              I help leaders and organizations create sustainable performance through 
              conscious leadership and workplace well-being strategies.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection('#contact')}
                data-testid="hero-cta-primary"
                className="btn-primary"
              >
                Book a Discovery Call
                <HiArrowRight className="w-5 h-5" />
              </button>
              
              <button
                onClick={() => scrollToSection('#services')}
                data-testid="hero-cta-secondary"
                className="btn-secondary"
              >
                Explore Services
              </button>
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="order-1 lg:order-2 relative flex justify-center lg:justify-end"
          >
            <div className="relative w-full max-w-md lg:max-w-lg">
              {/* Background shape */}
              <div className="absolute inset-0 bg-[#F3EFEB] rounded-full transform translate-x-4 translate-y-4" />
              
              {/* Decorative accent */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#7A8B71]/30 rounded-full blur-xl" />
              <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-[#7A8B71]/20 rounded-full blur-2xl" />
              
              {/* Portrait image */}
              <div className="relative aspect-square rounded-full overflow-hidden border-4 border-[#FDFBF7] shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_leadership-growth-4/artifacts/l0as65vj_Susana%20image.jpeg"
                  alt="Susana - Leadership Advisor"
                  className="w-full h-full object-cover object-top"
                  data-testid="hero-portrait"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="w-6 h-10 border-2 border-[#0A192F]/30 rounded-full flex justify-center pt-2"
        >
          <div className="w-1.5 h-1.5 bg-[#0A192F]/50 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
